/**
 * 設定画面 — 5 タブ構成（v2: 管理者管理は /admin/users へ移行）。
 * 仕様書:
 *   - docs/01_spec/spec_common.md C-1.4 （旧仕様）
 *   - docs/01_spec/spec_user_management.md （v2: ロール設定タブ追加）
 *
 * タブ:
 *   ① 一般設定
 *   ② 通知設定
 *   ③ シークレット管理（owner のみ）
 *   ④ ロール設定（owner のみ）
 *   ⑤ 監査ログ（owner のみ）
 */
import { Screen } from '@/components/layout/Screen';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useAuth } from '@/hooks/useAuth';

import { AdImageMigrationTab } from './tabs/AdImageMigrationTab';
import { AuditLogsTab } from './tabs/AuditLogsTab';
import { CustomFontsTab } from './tabs/CustomFontsTab';
import { GeneralSettingsTab } from './tabs/GeneralSettingsTab';
import { GoogleTagTab } from './tabs/GoogleTagTab';
import { NotificationsHubTab } from './tabs/NotificationsHubTab';
import { RoleSettingsTab } from './tabs/RoleSettingsTab';
import { SecretsManagementTab } from './tabs/SecretsManagementTab';

export function SettingsPage() {
  const { user } = useAuth();
  const isOwner = Boolean(user?.isOwner);

  return (
    <Screen
      title="設定"
      description="一般設定・通知・シークレット・ロール設定・監査ログを管理します"
    >
      <Tabs defaultValue="general">
        <TabsList>
          <TabsTrigger value="general">① 一般設定</TabsTrigger>
          <TabsTrigger value="notifications">② 通知</TabsTrigger>
          <TabsTrigger value="fonts">③ フォント管理</TabsTrigger>
          {isOwner && <TabsTrigger value="secrets">④ シークレット管理</TabsTrigger>}
          {isOwner && <TabsTrigger value="roles">⑤ ロール設定</TabsTrigger>}
          {isOwner && <TabsTrigger value="audit">⑥ 監査ログ</TabsTrigger>}
          {isOwner && <TabsTrigger value="ad-migration">⑦ 広告画像移行</TabsTrigger>}
          {isOwner && <TabsTrigger value="google-tag">⑧ Googleタグ</TabsTrigger>}
        </TabsList>

        <TabsContent value="general">
          <GeneralSettingsTab />
        </TabsContent>

        <TabsContent value="notifications">
          <NotificationsHubTab />
        </TabsContent>

        <TabsContent value="fonts">
          <CustomFontsTab />
        </TabsContent>

        {isOwner && (
          <TabsContent value="secrets">
            <SecretsManagementTab />
          </TabsContent>
        )}

        {isOwner && (
          <TabsContent value="roles">
            <RoleSettingsTab />
          </TabsContent>
        )}

        {isOwner && (
          <TabsContent value="audit">
            <AuditLogsTab />
          </TabsContent>
        )}

        {isOwner && (
          <TabsContent value="ad-migration">
            <AdImageMigrationTab />
          </TabsContent>
        )}

        {isOwner && (
          <TabsContent value="google-tag">
            <GoogleTagTab />
          </TabsContent>
        )}
      </Tabs>
    </Screen>
  );
}
